import { render, staticRenderFns } from "./ch-icon.vue?vue&type=template&id=f99322bc"
import script from "./ch-icon.vue?vue&type=script&lang=js"
export * from "./ch-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports